export const mapCurrencyToSymbol = (currency: string) => {
  const lowerCaseCurrency = currency.toLowerCase();
  switch (lowerCaseCurrency) {
    case 'eur':
      return '€';
    case 'usd':
    case 'cad':
      return '$';
    case 'gbp':
      return '£';
    default:
      return currency;
  }
};
